// Raptor Platform store types

export interface RaptorPlatformStore {
  raptorPlatformId: string | undefined; // UUID string or undefined
}

// Constants
export const SET_RAPTOR_PLATFORM_ID = 'SET_RAPTOR_PLATFORM_ID';
export type SET_RAPTOR_PLATFORM_ID = typeof SET_RAPTOR_PLATFORM_ID;

// Actions
export interface ISetRaptorPlatformId {
  type: SET_RAPTOR_PLATFORM_ID;
  raptorPlatformId: string | undefined; // UUID string or undefined
}

export type RaptorPlatformAction = ISetRaptorPlatformId;
